import { Export } from '../types';
import { apiClient } from './api';

interface ExportsResponse {
  data: Export[];
}

interface ExportResponse {
  data: Export;
}

interface DownloadExportResponse {
  download_url: string;
  filename: string;
  expires_in: number;
}

class ExportsService {
  private baseUrl = '/exports';

  async getExports(status?: string): Promise<ExportsResponse> {
    const params = status ? `?status=${status}` : '';
    const response = await apiClient.get<ExportsResponse>(
      `${this.baseUrl}${params}`
    );
    return response.data;
  }

  async getExport(exportId: string): Promise<ExportResponse> {
    const response = await apiClient.get<ExportResponse>(
      `${this.baseUrl}/${exportId}`
    );
    return response.data;
  }

  async downloadExport(exportId: string): Promise<DownloadExportResponse> {
    const response = await apiClient.get<DownloadExportResponse>(
      `${this.baseUrl}/${exportId}/download`
    );
    return response.data;
  }

  async retryExport(exportId: string): Promise<ExportResponse> {
    const response = await apiClient.post<ExportResponse>(
      `${this.baseUrl}/${exportId}/retry`
    );
    return response.data;
  }
}

export const exportsService = new ExportsService();
